// extracted by mini-css-extract-plugin
export default {"baseBtn":"ProfileButton_baseBtn__96rg5","isActive":"ProfileButton_isActive__kDGb7"};